var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.3 13.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69,8.57c-.12,.21-.34,.33-.57,.33-.11,0-.22-.03-.32-.08l-2.47-1.39c-.21-.12-.33-.33-.33-.57V2.9c0-.36,.29-.65,.65-.65s.65,.29,.65,.65v3.58l2.14,1.2c.31,.18,.42,.57,.25,.89Zm3.61-1.92c0,3.67-2.98,6.65-6.65,6.65S0,10.32,0,6.65,2.98,0,6.65,0s6.65,2.98,6.65,6.65Zm-1.3,0c0-2.95-2.4-5.35-5.35-5.35S1.3,3.7,1.3,6.65s2.4,5.35,5.35,5.35,5.35-2.4,5.35-5.35Z",
    fill: "#41319c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.3c781e470a87041ba718c2b3971aa14b.svg";
export { ForwardRef as ReactComponent };